import actions from '../constants';
import organizationRoot from '../../../utilities/organizationRoot';
import errorAction from '../../errorAction';

export default () => async (dispatch, getState) => {
  dispatch({ type: actions.GET_START });

  try {
    const snapshot = await organizationRoot(getState).child('sessions').once('value');
    return dispatch({ type: actions.GET_FINISH, payload: snapshot.val() });
  }
  catch (err) {
    return dispatch(errorAction(actions.GET_ERROR, err));
  }
};



// WEBPACK FOOTER //
// ./src/modules/sessions/actions/getSessions.js